var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.594 2.844h-7.18L6.335 15.837c.19.095.394.163.618.163h7.64C15.37 16 16 15.37 16 14.594V4.25c0-.775-.63-1.406-1.406-1.406Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.308 12.746.25 2.022c.05.402.321.841.777 1.07.912-.981.3-.355 2.463-2.682l-3.49-.41Z",
    fill: "#337AB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.798 13.156c.154-.175.288-.293.252-.534L7.63 1.232A1.408 1.408 0 0 0 6.235 0H1.406C.631 0 0 .63 0 1.406V11.75c0 .775.63 1.406 1.406 1.406h7.392Z",
    fill: "#00467F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.178 3.69a.47.47 0 0 0-.46-.377h-.937a.47.47 0 0 0-.46.376l-.937 4.688a.469.469 0 0 0 .92.184l.299-1.498h1.294l.3 1.498a.469.469 0 1 0 .919-.184l-.938-4.688Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "m3.79 6.125.375-1.875h.17l.375 1.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.625 7.063h-1.406v-.47a.468.468 0 1 0-.938 0v.47H9.875a.468.468 0 1 0 0 .937H10a5.918 5.918 0 0 0 1.098 2.053c-.344.315-.681.573-1.047.862a.468.468 0 1 0 .586.732c.397-.314.74-.577 1.113-.92.373.343.716.606 1.113.92a.468.468 0 1 0 .586-.732c-.366-.289-.703-.547-1.047-.862A5.916 5.916 0 0 0 13.5 8h.125a.468.468 0 1 0 0-.938Z",
    fill: "#53565C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 9.358A4.9 4.9 0 0 1 10.98 8h1.54a4.899 4.899 0 0 1-.77 1.358Z",
    fill: "#53565C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.92118573a3441564755428b4019bafe6.svg";
export { ForwardRef as ReactComponent };